import { container } from 'tsyringe'
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators'
import store from '@/app/store/store'
import {
  TrainingMaterialApiRequest,
  UpdateTrainingMaterialRequest,
  DeleteTrainingMaterialRequest,
} from '@/data/payload/api/TrainingMaterialRequest'
import { TrainingMaterialPresenter } from '@/app/ui/presenters/TrainingMaterialPresenter'
import { TrainingMaterial } from '@/domain/entities/TrainingMaterial'
import router from '@/router'
import Vue from 'vue'
import { AuthModule } from './auth'

export interface TrainingMaterialState {
  trainingMaterialData: TrainingMaterial
  isLoading: boolean
  fields: any
  paginationParam: Object
}

@Module({ namespaced: true, dynamic: true, store, name: 'trainingMaterials' })
class TrainingMaterials extends VuexModule implements TrainingMaterialState {
  public trainingMaterialData = new TrainingMaterial(true, '')
  public isLoading = true
  public Pages = 0
  public Limit = 10
  public fields = [
    { key: 'selected', sortable: false },
    { key: 'no', sortable: false },
    { key: 'name', sortable: true },
    { key: 'totalFiles', sortable: false },
    { key: 'isActive', sortable: false },
    { key: 'updatedAt', sortable: false },
    { key: 'createdAt', sortable: false },
    { key: 'actions', sortable: false },
  ]
  public paginationParam = {
    paging: {
      page: 1,
      limit: 10,
    },
    sort: {
      column: 'CreateDate',
      type: 'desc',
    },
    filter: {
      category: 1,
    },
    search: '',
  }

  @Action
  public async getTrainingMaterialData() {
    this.setLoading(true)
    const presenter = await container.resolve(TrainingMaterialPresenter)
    presenter
      .loadTrainingMaterial(this.paginationParam)
      .then((res: TrainingMaterial) => {
        this.setLoading(false)
        this.setTrainingMaterialData(res)
        this.setpages(this.paginationParam.paging.page)
        this.setlimit(this.paginationParam.paging.limit)
        //  console.log('data', res)
      })
      .catch((error) => {
        this.setLoading(false)
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        router.push('/404/index')
        console.error('error', error)
      })
  }

  @Action
  public async postTrainingMaterial(params: {
    title: string
    fileCode: string
    imageThumbnailId: number
    ownerId: string
    fileName: string
    fileByte: string
    fileUpload: any
    isRecommended: boolean
    categoryId: number
    expireddate: string
  }) {
    this.setLoading(true)
    const presenter = await container.resolve(TrainingMaterialPresenter)
    presenter
      .postTrainingMaterial(
        new TrainingMaterialApiRequest(
          params.title,
          params.fileCode,
          params.imageThumbnailId,
          params.fileName,
          params.fileByte,
          params.fileUpload,
          params.isRecommended,
          params.categoryId,
          params.expireddate,
          params.ownerId
        )
      )
      .then((res) => {
        //  console.log(res)
        Vue.prototype.$notify({
          title: 'Training Material',
          message: res.message,
          type: res.success === true ? 'success' : 'error',
          duration: 5000,
        })
        this.getTrainingMaterialData()
      })
      .catch((error) => {
        this.setLoading(false)
        //  console.log(error)
      })
  }

  @Action
  public async updateTrainingMaterial(params: {
    id: number
    fileCode: string
    title: string
    recommended: boolean
    imageThumbnailId: number
    fileName: string
    fileByte: string
    fileUpload: any
    expireddate: string
  }) {
    this.setLoading(true)
    const presenter = await container.resolve(TrainingMaterialPresenter)
    presenter
      .updateTrainingMaterial(
        new UpdateTrainingMaterialRequest(
          params.title,
          params.fileCode,
          params.recommended,
          params.imageThumbnailId,
          params.fileName,
          params.fileByte,
          params.fileUpload,
          params.expireddate
        ),
        params.id
      )
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Training Material',
          message: res.message,
          type: res.success === true ? 'success' : 'error',
          duration: 5000,
        })
        this.getTrainingMaterialData()
      })
      .catch((error) => {
        this.setLoading(false)
        //  console.log(error)
      })
  }

  @Action
  public async deleteTrainingMaterial(params: { ids: any }) {
    this.setLoading(true)
    const presenter = await container.resolve(TrainingMaterialPresenter)
    presenter
      .deleteTrainingMaterial(new DeleteTrainingMaterialRequest(params.ids))
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Training Material',
          message: res.message,
          type: res.success === true ? 'success' : 'error',
          duration: 5000,
        })
        this.getTrainingMaterialData()
      })
      .catch((error) => {
        this.setLoading(false)
        //  console.log(error)
      })
  }

  @Mutation
  private setTrainingMaterialData(trainingMaterial: TrainingMaterial) {
    this.trainingMaterialData = trainingMaterial
  }

  @Mutation
  private setLoading(isLoading: boolean) {
    this.isLoading = isLoading
  }
  @Mutation
  private setpages(pages: number) {
    this.Pages = pages
  }
  @Mutation
  private setlimit(limit: number) {
    this.Limit = limit
  }
}

export const trainingMaterialDataModule = getModule(TrainingMaterials)
